export const COMMIT = 'commit'
export const DID = 'did'
export const DIDNOT = 'didnot'
export const COMPLETE = 'complete'
